<template>
  <v-dialog :value="value" max-width="520px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="d-flex align-center py-3">
        <v-icon left small>fa fa-history</v-icon>
        <span class="text-subtitle-1 font-weight-medium">Histórico da turma</span>
        <v-spacer />
        <v-btn icon small @click="$emit('input', false)" aria-label="Fechar">
          <v-icon small>fa fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4 pb-2">
        <p v-if="turmaDescricao" class="historico-turma">{{ turmaDescricao }}</p>

        <div v-if="carregando" class="text-center py-8">
          <v-progress-circular indeterminate size="28" width="3" color="primary" />
        </div>

        <p v-else-if="erro" class="historico-aviso historico-aviso--erro">
          Não foi possível carregar o histórico. Tente novamente.
        </p>

        <p v-else-if="!registros.length" class="historico-aviso">
          Esta turma ainda não foi fechada nenhuma vez.
        </p>

        <ol v-else class="historico">
          <li v-for="(registro, i) in registros" :key="i" class="historico__item">
            <span class="historico__marco" :class="`historico__marco--${registro.acao}`"></span>
            <div>
              <p class="historico__acao">
                {{ registro.acao === "fechamento" ? "Fechada" : "Reaberta" }}
              </p>
              <p class="historico__meta">
                {{ formatarData(registro.data) }} · {{ registro.usuario }}
              </p>
            </div>
          </li>
        </ol>
      </v-card-text>

      <v-divider v-if="registros.length" />

      <v-card-actions v-if="registros.length" class="px-4 py-2">
        <v-spacer />
        <v-btn text small color="primary" :loading="gerandoPdf" @click="imprimir">
          <v-icon left x-small>fa fa-print</v-icon>
          Imprimir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalHistoricoTurma",
  props: {
    value: { type: Boolean, default: false },
    turma: { type: Object, default: null },
  },
  data() {
    return {
      carregando: false,
      gerandoPdf: false,
      erro: false,
      registros: [],
      turmaDescricao: "",
    };
  },
  watch: {
    value(aberto) {
      if (aberto) {
        this.carregarHistorico();
      }
    },
  },
  methods: {
    async carregarHistorico() {
      if (!this.turma) {
        return;
      }

      this.carregando = true;
      this.erro = false;
      this.registros = [];

      try {
        const { turma, registros } = await this.$services.turmasService.historicoFechamento(
          this.turma
        );
        this.turmaDescricao = turma;
        this.registros = registros;
      } catch (error) {
        this.erro = true;
      }

      this.carregando = false;
    },
    formatarData(data) {
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async imprimir() {
      this.gerandoPdf = true;

      try {
        await this.$services.turmasService.gerarRelatorioHistoricoFechamento(this.turma);
      } catch (error) {
        this.$toast.danger("Não foi possível gerar o relatório");
      }

      this.gerandoPdf = false;
    },
  },
};
</script>

<style scoped>
.historico-turma {
  font-size: 0.9375rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  margin: 0 0 16px;
}

.historico-aviso {
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  padding: 24px 0;
  margin: 0;
}

.historico-aviso--erro {
  color: #c62828;
}

.historico {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Linha contínua ligando os marcos, encerrada no último item. */
.historico__item {
  position: relative;
  display: flex;
  gap: 14px;
  padding: 0 0 18px 2px;
}

.historico__item::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 14px;
  bottom: 0;
  width: 1px;
  background: #e0e0e0;
}

.historico__item:last-child {
  padding-bottom: 0;
}

.historico__item:last-child::before {
  display: none;
}

.historico__marco {
  flex-shrink: 0;
  width: 11px;
  height: 11px;
  margin-top: 4px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px currentColor;
}

.historico__marco--fechamento {
  color: #78909c;
  background: #78909c;
}

.historico__marco--reabertura {
  color: #2e7d32;
  background: #2e7d32;
}

.historico__acao {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}

.historico__meta {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.55);
  margin: 1px 0 0;
}
</style>
